export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  image: string;
  publishDate: string;
  author: string;
  readTime: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 'a001',
    title: '如何挑选一颗完美的水蜜桃——从外观到香气的全方位指南',
    summary: '学会辨别水蜜桃的成熟度，从色泽、触感、香气等维度挑选出最甜蜜的那一颗。本文为您详细解析专业选桃技巧。',
    content: `<p>水蜜桃是夏季最受欢迎的水果之一，但很多人在挑选时往往无从下手。一颗完美的水蜜桃，需要从多个维度来评判。</p>
<h4 id="appearance">外观色泽</h4>
<p>优质水蜜桃的果皮应该呈现出自然的红润色泽，颜色均匀且有光泽。过于青涩说明采摘过早，而颜色过深或出现暗斑则可能是过度成熟的表现。阳山水蜜桃以白里透红、色泽粉嫩著称，龙泉驿水蜜桃则偏深粉色，各有特色。</p>
<h4 id="texture">触摸手感</h4>
<p>轻轻捏一下桃子的果肩部位（靠近果柄的两侧），应该感觉到适度的弹性。太硬说明还未完全成熟，太软则已经过度成熟。真正恰到好处的水蜜桃，手感应该是"似软非软"，有一种独特的Q弹感。</p>
<h4 id="aroma">香气辨识</h4>
<p>靠近闻一闻，成熟的优质水蜜桃会散发出浓郁而清甜的果香。如果几乎闻不到香味，说明还未成熟；如果有发酵或酒精味，则已经过度成熟或开始变质。奉化玉露水蜜桃的香气尤为独特，有一种类似花蜜的芬芳。</p>
<h4 id="weight">重量手感</h4>
<p>同等大小的水蜜桃，越重说明水分越充足，口感会更加多汁。这也是为什么阳山水蜜桃如此受欢迎——它的含水量极高，拿在手里有沉甸甸的满足感。</p>
<h4 id="conclusion">总结</h4>
<p>挑选水蜜桃的核心要诀：看色泽红润均匀、摸果肩有弹性、闻香气浓郁清甜、掂重量水分充足。掌握了这些技巧，您也能轻松挑出最美味的蜜桃。</p>`,
    category: '选购指南',
    image: 'https://readdy.ai/api/search-image?query=A%20person%20carefully%20selecting%20ripe%20peaches%20at%20a%20farmers%20market%2C%20hands%20gently%20holding%20a%20beautiful%20pink%20peach%2C%20warm%20sunlight%2C%20wooden%20crates%20filled%20with%20fresh%20peaches%2C%20lifestyle%20photography%2C%20natural%20warm%20tones%2C%20shallow%20depth%20of%20field&width=1200&height=600&seq=article-pick-01&orientation=landscape',
    publishDate: '2026-07-15',
    author: '蜜桃小管家',
    readTime: '5分钟',
    tags: ['水蜜桃', '选购技巧', '水果知识', '生活指南'],
  },
  {
    id: 'a002',
    title: '水蜜桃的正确保存方法——延长甜蜜赏味期的秘诀',
    summary: '买回家的水蜜桃如何保存才能保持最佳口感？不同成熟度的桃子保存方法大不同，掌握这些技巧让蜜桃美味更持久。',
    content: `<p>水蜜桃是娇贵的水果，保存不当很容易导致口感下降甚至变质。掌握正确的保存方法，才能最大程度地延长它的甜蜜赏味期。</p>
<h4 id="unripe">未成熟桃子的保存</h4>
<p>如果买到的桃子还偏硬、未完全成熟，不要急着放入冰箱。正确做法是将桃子放在室温下（20-25℃），避免阳光直射，平铺摆放不要堆叠。一般1-3天后桃子就会自然成熟变软，散发浓郁香气。</p>
<h4 id="ripe">成熟桃子的保存</h4>
<p>已经完全成熟的水蜜桃，如果当天不吃，需要用保鲜袋或保鲜膜包裹后放入冰箱冷藏（2-4℃）。注意不要清洗后再放入冰箱，因为水分会加速变质。冷藏可以保存3-5天。</p>
<h4 id="tips">保存小贴士</h4>
<p>桃子之间最好保持一定间距，避免相互挤压造成损伤。如果桃子表面有绒毛，保存时尽量不要触碰摔打，绒毛脱落后会加速水分流失。建议每天检查一次，将有软烂迹象的优先食用。</p>
<h4 id="freeze">冷冻保存法</h4>
<p>如果想长期保存，可以将水蜜桃去皮去核切片，撒少许柠檬汁防止氧化变色，放入密封袋中冷冻。冷冻桃子可以保存3个月，适合用来制作果汁、冰沙或烘焙甜品。</p>
<h4 id="conclusion">总结</h4>
<p>记住核心原则：硬桃室温放软、软桃冷藏保鲜、吃不完冷冻保存。按照这个流程操作，就能充分享受水蜜桃的最佳风味。</p>`,
    category: '保存技巧',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20peaches%20neatly%20arranged%20in%20a%20refrigerator%20drawer%20with%20soft%20lighting%2C%20some%20in%20paper%20bags%2C%20clean%20organized%20kitchen%20storage%2C%20warm%20natural%20light%20from%20fridge%20interior%2C%20food%20storage%20photography%2C%20clean%20composition&width=1200&height=600&seq=article-store-01&orientation=landscape',
    publishDate: '2026-07-10',
    author: '蜜桃小管家',
    readTime: '4分钟',
    tags: ['水蜜桃', '保存方法', '生活妙招', '食材保鲜'],
  },
  {
    id: 'a003',
    title: '中国三大水蜜桃产区巡礼——阳山、龙泉驿、奉化谁更胜一筹',
    summary: '深入了解中国最负盛名的三大水蜜桃产区，从地理环境、品种特色到口感风味，为您全面解读各地水蜜桃的独特魅力。',
    content: `<p>中国是水蜜桃的故乡，拥有众多优质产区。其中，江苏无锡阳山、四川成都龙泉驿、浙江宁波奉化并称为中国三大水蜜桃产区，各具特色，各有拥趸。</p>
<h4 id="yangshan">阳山水蜜桃——"桃中极品"</h4>
<p>阳山镇地处太湖之滨，独特的火山灰土壤富含矿物质，加上温暖湿润的气候，为水蜜桃生长提供了得天独厚的条件。阳山水蜜桃以果大色美、皮薄肉厚、汁多味甜闻名，单果可达300g以上。白凤、湖景蜜露等经典品种享誉全国。每年的7月中旬至8月中旬是最佳品尝期。</p>
<h4 id="longquanyi">龙泉驿水蜜桃——"天府之桃"</h4>
<p>四川成都龙泉驿区位于成都平原东部，拥有"中国水蜜桃之乡"的美誉。这里四季分明、日照充足，特别适合水蜜桃糖分的积累。龙泉驿水蜜桃果肉细腻柔软，口感鲜嫩多汁，甜度适中而不腻，带有独特的清香。每年6月至8月是龙泉驿水蜜桃的丰收季节。</p>
<h4 id="fenghua">奉化水蜜桃——"琼浆玉露"</h4>
<p>浙江宁波奉化区栽培水蜜桃已有2000多年历史，是"中国水蜜桃之乡"。奉化最著名的是"玉露"品种，皮薄如纸，甚至可以剥皮食用，果肉入口即化，汁水丰沛甜如蜜，被誉为"琼浆玉露"。奉化水蜜桃每年7月下旬至8月上旬成熟，赏味期较短但风味绝佳。</p>
<h4 id="comparison">三大产区对比</h4>
<p>阳山水蜜桃胜在果大形美、送礼体面；龙泉驿水蜜桃长在细腻柔软、性价比高；奉化水蜜桃妙在皮薄汁多、风味独特。三者各有千秋，都是中国水蜜桃的瑰宝。</p>`,
    category: '产区知识',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20peach%20orchard%20in%20morning%20light%2C%20rows%20of%20peach%20trees%20heavy%20with%20ripe%20pink%20peaches%2C%20misty%20mountains%20in%20background%2C%20pastoral%20Chinese%20countryside%2C%20warm%20golden%20sunlight%2C%20peaceful%20agricultural%20landscape%20photography&width=1200&height=600&seq=article-regions-01&orientation=landscape',
    publishDate: '2026-07-05',
    author: '蜜桃小管家',
    readTime: '6分钟',
    tags: ['水蜜桃', '产区介绍', '阳山', '龙泉驿', '奉化'],
  },
  {
    id: 'a004',
    title: '水蜜桃的营养价值与健康功效——不只是好吃那么简单',
    summary: '水蜜桃不仅美味可口，还富含多种营养成分。了解水蜜桃的营养价值，让您在享受甜蜜的同时收获健康。',
    content: `<p>水蜜桃被誉为"果中皇后"，不仅因为其美味，更因为它含有丰富的营养成分，对人体健康有诸多益处。</p>
<h4 id="nutrition">营养成分</h4>
<p>每100克水蜜桃含热量约39千卡，富含维生素A、维生素C、维生素E及多种B族维生素。矿物质方面，含有丰富的钾、镁、铁、磷等。此外还含有膳食纤维、果胶和多种抗氧化物质。</p>
<h4 id="skin">美容养颜</h4>
<p>水蜜桃中的维生素C和抗氧化物质有助于抑制黑色素形成，促进胶原蛋白合成，让皮肤更加白皙光滑。丰富的果胶和水分还能帮助排毒养颜，保持肌肤水润弹性。</p>
<h4 id="digestion">促进消化</h4>
<p>水蜜桃含有的膳食纤维和果胶可以促进肠道蠕动，帮助消化，预防便秘。同时，桃子中的有机酸能刺激消化液分泌，增进食欲。</p>
<h4 id="heart">心血管保护</h4>
<p>水蜜桃富含钾元素，有助于维持体内钠钾平衡，对控制血压有积极作用。其中的多酚类物质还具有抗氧化的功效，有助于保护心血管健康。</p>
<h4 id="conclusion">食用建议</h4>
<p>每天食用1-2颗水蜜桃即可获取充足的营养。建议在两餐之间食用，既可作为健康零食，又能避免与正餐同时摄入过多糖分。但糖尿病患者应适量食用，最好咨询医生建议。</p>`,
    category: '健康知识',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20flat%20lay%20of%20fresh%20peaches%20surrounded%20by%20nutrition%20related%20items%2C%20like%20a%20glass%20of%20water%20and%20green%20leaves%2C%20natural%20morning%20light%2C%20cream%20marble%20surface%2C%20wellness%20lifestyle%20photography%2C%20clean%20fresh%20aesthetic&width=1200&height=600&seq=article-nutrition-01&orientation=landscape',
    publishDate: '2026-06-28',
    author: '蜜桃小管家',
    readTime: '5分钟',
    tags: ['水蜜桃', '营养价值', '健康饮食', '生活百科'],
  },
  {
    id: 'a005',
    title: '蜜桃甜品DIY——3款简单又惊艳的水蜜桃甜点做法',
    summary: '用新鲜水蜜桃制作精致甜品，从蜜桃奶冻到蜜桃塔，简单易学的做法让您在家也能享受高级甜品的乐趣。',
    content: `<p>水蜜桃是制作甜品的绝佳食材，天然的甜味和诱人的色泽，让每一款甜品都充满夏日气息。今天教大家3款简单又惊艳的蜜桃甜品。</p>
<h4 id="pudding">蜜桃椰奶冻</h4>
<p>将水蜜桃去皮切丁，吉利丁片泡软。椰奶加糖小火加热至微温，加入泡软的吉利丁搅拌至融化。杯底放入蜜桃丁，倒入椰奶液，冷藏4小时以上。食用前表面摆放新鲜蜜桃片装饰，清甜爽滑，入口即化。</p>
<h4 id="tart">蜜桃杏仁塔</h4>
<p>将水蜜桃切成薄片备用。塔皮预烤至金黄，填入杏仁奶油馅，整齐排列蜜桃片，撒上杏仁片，再次烘烤至表面微焦。出炉后刷一层蜂蜜水增加光泽。蜜桃的酸甜与杏仁的香脆完美融合。</p>
<h4 id="smoothie">蜜桃冰沙</h4>
<p>最简单也最消暑的吃法！将冰镇水蜜桃去皮去核切块，与冰块、少许蜂蜜和柠檬汁一起放入搅拌机，打成细腻冰沙。装杯后点缀薄荷叶，清爽解暑，是夏天最受欢迎的健康饮品。</p>
<h4 id="tips">制作小贴士</h4>
<p>选择完全成熟的水蜜桃制作甜品，甜度和香气最佳。如果桃子偏酸，可以适当增加糖或蜂蜜的用量。制作冰沙时加少许柠檬汁不仅能增添风味，还能防止桃子氧化变色。</p>`,
    category: '美食食谱',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20homemade%20peach%20dessert%20tart%20on%20a%20ceramic%20plate%2C%20golden%20crust%20with%20sliced%20pink%20peaches%20arranged%20in%20a%20rose%20pattern%2C%20powdered%20sugar%20dusting%2C%20soft%20window%20light%2C%20cream%20linen%20background%2C%20food%20blog%20photography%20style&width=1200&height=600&seq=article-recipe-01&orientation=landscape',
    publishDate: '2026-06-20',
    author: '蜜桃小管家',
    readTime: '5分钟',
    tags: ['水蜜桃', '甜品食谱', 'DIY', '美食制作'],
  },
  {
    id: 'a006',
    title: '为什么送礼要选水蜜桃礼盒——解析蜜桃礼盒的社交价值',
    summary: '在中国传统文化中，桃子象征着长寿与吉祥。送水蜜桃礼盒不仅是送美味，更是传递美好祝愿的最佳方式。',
    content: `<p>在中国传统文化中，桃子一直被视为吉祥之果。"蟠桃献寿"的故事家喻户晓，桃子象征着长寿、健康与幸福。选择水蜜桃礼盒作为礼物，有着深厚的文化内涵和美好的寓意。</p>
<h4 id="culture">文化寓意</h4>
<p>桃子在中国文化中有着特殊地位。《西游记》中的蟠桃盛会，《诗经》中的"投我以木桃，报之以琼瑶"，都体现了桃子的文化厚度。送桃子，就是送长寿、送健康、送甜蜜。</p>
<h4 id="quality">品质象征</h4>
<p>一盒精心挑选的水蜜桃礼盒，代表的是送礼人的品位和心意。每一颗饱满红润的水蜜桃，都是品质生活的写照。相比常见的保健品、烟酒，水蜜桃礼盒更加健康、清新，更能体现送礼人的独特眼光。</p>
<h4 id="occasions">适用场合</h4>
<p>水蜜桃礼盒适合多种送礼场合：节日走访亲友、探望长辈、商务往来、生日祝福、乔迁之喜等。尤其是每年6-8月蜜桃季，送上一份新鲜的时令蜜桃礼盒，既应季又贴心。</p>
<h4 id="choose">如何选择送礼蜜桃</h4>
<p>送礼用的水蜜桃，首选大果礼盒装。单果250g以上的特级果，果形端正、色泽红润，包装精美大方。美丽的小蜜桃提供的精品水蜜桃礼盒，每一颗都经过严格筛选，搭配精美包装和手提袋，送礼更有面子。</p>`,
    category: '文化礼俗',
    image: 'https://readdy.ai/api/search-image?query=An%20elegant%20peach%20gift%20box%20being%20presented%20with%20both%20hands%2C%20warm%20smiling%20atmosphere%2C%20beautiful%20wooden%20box%20with%20premium%20peaches%20visible%2C%20soft%20natural%20light%2C%20warm%20cream%20interior%2C%20lifestyle%20photography%2C%20Chinese%20gift%20giving%20culture&width=1200&height=600&seq=article-gift-01&orientation=landscape',
    publishDate: '2026-06-15',
    author: '蜜桃小管家',
    readTime: '4分钟',
    tags: ['水蜜桃', '送礼文化', '礼盒', '传统文化'],
  },
];

export const articleCategories = [
  { slug: 'all', name: '全部文章' },
  { slug: 'guide', name: '选购指南' },
  { slug: 'storage', name: '保存技巧' },
  { slug: 'regions', name: '产区知识' },
  { slug: 'health', name: '健康知识' },
  { slug: 'recipes', name: '美食食谱' },
  { slug: 'culture', name: '文化礼俗' },
];